import types from "../actionTypes";

export default (
  state = {
    maxSteps: 0,
    minSteps: 0,
    step: 1,
    isAdded: false,
    accomodationFormPdfLink: undefined,
    applicants: [],
    currentPage: 1,
    pageSize: 20,
    totalRows: 0,
    caseStatus: [],
    acmdEmployeeStatement: [],
    attachment: []
  },
  action
) => {
  switch (action.type) {
    case types.SET_CCM_CASE_STATUS:
      return Object.assign({}, state, {
        caseStatus: action.caseStatus
      })
    case types.SET_CCM_PAGE_NO:
      return Object.assign({}, state, {
        currentPage: action.currentPage
      })
    case types.SET_CCM_PAGE_ROWS:
      return Object.assign({}, state, {
        totalRows: action.totalRows
      })
    case types.SET_CCM_PAGE_SIZE:
      return Object.assign({}, state, {
        pageSize: action.pageSize
      })
    case types.SET_CCM_APPLICANTS:
      return Object.assign({}, state, {
        applicants: action.applicant
      })
    case types.SET_CCM_CURRENT_STEP:
      return Object.assign({}, state, { step: action.step });
    case types.SET_CCM_MAX_STEPS:
      return Object.assign({}, state, { maxSteps: action.maxSteps });
    case types.SET_CCM_MIN_STEPS:
      return Object.assign({}, state, { minSteps: action.minSteps });
    case types.SET_CCM_IS_ADDED:
      return Object.assign({}, state, { isAdded: action.isAdded });
    case types.SET_CCM_FORM_PDF:
      return Object.assign({}, state, { accomodationFormPdfLink: action.accomodationFormPdfLink });
    case types.SET_CCM_STATEMENT:
      return Object.assign({}, state, { ccmEmployeeStatement: action.ccmEmployeeStatement });
    case types.SET_ATTACHMENT_CCM:
      return Object.assign({}, state, {
        attachment: action.attachment,
      });
    default:
      return state;
  }
};
